//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'coupon-item',
  props: {
    coupon: Object,     // 优惠券数据
    isChecked: Boolean, // 是否被选中
  },
  computed: {
    /** 优惠券货币：优先取券自身货币，其次取用户所选货币 */
    currencyCode(){
      return (this.coupon && this.coupon.currency_code) || window.localStorage.getItem('currency_code') || 'CNY';
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/Coupon/CouponItem.vue